module.exports = __webpack_public_path__ + "static/redime-tus-puntos-1-AR-3db84ff03fea4ae16364ffa0ba804bae.png";